import * as Icons from 'basic-components/icons';

const getIcon = ({ bgColor, color = "white-base", icon, size = 20 }) => {
  const IconEl = icon && Icons[icon] ? Icons[icon] : Icons.HomeIcon
  return (
    <IconEl
        bgColor={bgColor}
        color={color}
        height={size} 
        width={size}
    />
  )
}

export default getIcon;
